import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSubscription } from './subscription-context/SubscriptionContext';

/**
 * SubscriptionStatusGuard - Hard-redirects to /past-due-payment if subscription is past_due.
 * Placed inside the protected layout so any navigation within the app is caught.
 */
export const SubscriptionStatusGuard: React.FC = () => {
  const { isPastDue } = useSubscription();

  if (isPastDue) {
    return <Navigate to="/past-due-payment" replace />;
  }

  return null;
};

export default SubscriptionStatusGuard;
